// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"cc1ca9d8","453":"1290f5df","455":"435d83a1"}[chunkId] + ".chunk.js";
};